$('.ct2-slides').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false
      }
    }
  ]
});
$('.custom-vid-tes-slider').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 9000,
  arrows: false,
  dots: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$(function() {
  var waitForEl = setInterval(function() {

    if($('div#shopify-block-loox_reviews_loox_rating_nNiac4 a').length > 0){
        $('div#shopify-block-loox_reviews_loox_rating_nNiac4 a').attr('href','#shopify-section-template--23583004229917__17279255591294394a');
        
        clearInterval(waitForEl);
      
    }

  }, 10);
  
  $(".button").each(function() {
    if ($(this).attr("href") && $(this).attr("href").includes("wholesale")) {
      $(this).addClass("for-wholesale");
    }
  });
  
});

document.querySelectorAll('.ios-controls').forEach(function (video) {
  try {
    video.setAttribute('playsinline', '');
    video.muted = true; // Required for autoplay on mobile
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  } catch (e) {}
});

document.addEventListener('DOMContentLoaded', function () {
  var videoElements = document.querySelectorAll('.ios-controls');

  videoElements.forEach(function(videoElement) {
    videoElement.controls = false;

    videoElement.addEventListener('play', function () {
      this.controls = false;
    });

    videoElement.addEventListener('pause', function () {
      this.controls = false;
    });
  });
});


/* Sitewide scroll-in animation for major page blocks */
(function () {
  function run() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) {
        document.documentElement.classList.add('fll-no-io');
        return;
      }

      var SEL = [
        'main .shopify-section',
        '.fll-band', '.fll-hero', '.fll-providers', '.fll-cta', '.fll-submit',
        '.nr-sec', '.nr-trust', '.nr-grid3 > *', '.nr-tile', '.nr-card',
        '.fls-card', '.fll-card', '.fll-featured', '.fll-provider',
        '.product__info-wrapper', '.product__media-wrapper',
        '.collection .grid__item', '.product-grid .grid__item',
        '.rte h2', '.image-with-text', '.multicolumn-list__item',
        '.slideshow__slide', '.footer__content-top > *'
      ].join(',');

      var skipClosest = 'header, footer, .shopify-section-header, sticky-header, cart-drawer, .fll-modal, .fll-t, .section-fll-testimonials, .nr, .nr-modal, #nr-page, .announcement-bar, #shopify-section-announcement-bar';
      var nodes = [];
      document.querySelectorAll(SEL).forEach(function (el) {
        if (!el || el.classList.contains('fll-scroll-reveal')) return;
        if (el.classList.contains('scroll-trigger') || el.classList.contains('nr-reveal')) return;
        if (el.closest(skipClosest)) return;
        // Skip empty/tiny sections
        if (el.classList.contains('shopify-section') && el.children.length === 0) return;
        nodes.push(el);
      });

      nodes.forEach(function (el, i) {
        el.classList.add('fll-scroll-reveal');
        var d = (i % 3) + 1;
        if (d > 1) el.classList.add('fll-scroll-reveal--delay-' + (d - 1));
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('fll-scroll-reveal--in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

      nodes.forEach(function (el) {
        // If already mostly on screen at load, reveal immediately
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 40) {
          el.classList.add('fll-scroll-reveal--in');
        } else {
          io.observe(el);
        }
      });

      setTimeout(function () {
        document.querySelectorAll('.fll-scroll-reveal:not(.fll-scroll-reveal--in)').forEach(function (el) {
          el.classList.add('fll-scroll-reveal--in');
        });
      }, 4000);
    } catch (e) {
      console && console.warn && console.warn('fll scroll reveal', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Free Life Labs: force Loox rating icons to stars (not leaves) */
(function () {
  var STAR_FILL = '<path d="M12 2.5l2.9 6.1 6.6.6-5 4.4 1.5 6.5L12 16.8 5.9 20.1l1.5-6.5-5-4.4 6.6-.6L12 2.5z" fill="currentColor"></path>';
  var STAR_LINE = '<path d="M12 3.2l2.5 5.3 5.7.5-4.3 3.8 1.3 5.6L12 15.6 6.8 18.4l1.3-5.6-4.3-3.8 5.7-.5L12 3.2z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"></path>';
  function swap() {
    ['looxicons-rating-icon-fill', 'looxicons-rating-icon-line'].forEach(function (id) {
      var sym = document.getElementById(id);
      if (!sym || sym.dataset.fllStar === '1') return;
      sym.innerHTML = id.indexOf('line') >= 0 ? STAR_LINE : STAR_FILL;
      sym.dataset.fllStar = '1';
    });
  }
  swap();
  document.addEventListener('DOMContentLoaded', swap);
  // Loox may inject icons late
  var i = 0;
  var timer = setInterval(function () {
    swap();
    if (++i > 40) clearInterval(timer);
  }, 250);
})();


/* Shopify Inbox: show chat launcher only after an extended visit (or once per session). */
(function () {
  if (window.__fllChatDelay) return;
  window.__fllChatDelay = true;
  var DELAY_MS = 60000;
  var KEY = 'fll_chat_ready';
  function reveal() {
    try { document.documentElement.classList.add('fll-chat-ready'); } catch (e) {}
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }
  try {
    if (sessionStorage.getItem(KEY) === '1') {
      reveal();
      return;
    }
  } catch (e) {}
  setTimeout(reveal, DELAY_MS);
})();
